import { ConfirmCvsPaymentView } from "features/confirmCvsPayment/ConfirmCvsPaymentView";
import {
  isOrderTransaction,
  hasVariantOrderLineItem,
} from "features/orderModel";
import React from "react";
import { getEventDisplayInfo } from "utility";

import type { MyProductData } from "@spwn/types";
import type { Event, ActiveTransaction } from "@spwn/types/firebase/firestore";
import type { CVSCode, PhoneCode } from "@spwn/types/gmo";
import type {
  ConfirmCvsPaymentEventGroup,
  ConfirmCvsPaymentItem,
} from "features/confirmCvsPayment/confirmCvsPaymentViewProps";

type Props = {
  isOpen: boolean;
  unprocessData: UnProcessData[];
  cvsCode?: CVSCode;
  ReceiptNo?: string; //"LW192350584431"
  ConfNo?: string; //"2961"
  phoneCode?: PhoneCode;
  phoneURL?: string;
  paypalURL?: string;
  orderId: number;
  activeTransactionMap: { [orderId: string]: ActiveTransaction };
  close: () => void;
};

export type UnProcessData = {
  event: Event;
  ticketList: MyProductData[];
  goodsList: MyProductData[];
};

const toItems = (data: ActiveTransaction): ConfirmCvsPaymentItem[] => {
  if (isOrderTransaction(data)) {
    return data.lineItems.map((p) => ({
      name: p.name,
      variantName: hasVariantOrderLineItem(p) ? p.variantName : "",
      price: p.price,
      count: p.quantity,
    }));
  }
  return (data.products ?? []).map((p) => ({
    name: p.name,
    variantName: p.subClassName ?? "",
    price: p.price_jpy,
    count: p.count,
  }));
};

const toEventGroups = (
  unprocessData: UnProcessData[]
): ConfirmCvsPaymentEventGroup[] =>
  unprocessData.map((eventData) => {
    const {
      eventTitle,
      artists,
      eventOpenDateFull,
      eventEndDateFull,
      isLongEvent,
      eventOpenDay,
    } = getEventDisplayInfo(eventData.event);
    return {
      artists,
      eventEndDateFull,
      eventOpenDateFull,
      eventOpenDay,
      eventTitle,
      isLongEvent,
      products: eventData.ticketList.concat(eventData.goodsList),
    };
  });

/**
 * コンビニ決済確認
 */
const ConfirmCvsPayment = ({
  activeTransactionMap,
  unprocessData,
  orderId,
  cvsCode,
  ReceiptNo,
  ConfNo,
  phoneCode,
  phoneURL,
  paypalURL,
  isOpen,
  close,
}: Props) => {
  const data = activeTransactionMap?.[orderId];

  if (!unprocessData || !data) {
    return <div></div>;
  }

  return (
    <ConfirmCvsPaymentView
      close={close}
      cvsInfo={
        cvsCode ? { confNo: ConfNo, cvsCode, receiptNo: ReceiptNo } : null
      }
      errorInfo={data.errorInfo ?? null}
      eventGroups={
        isOrderTransaction(data) ? null : toEventGroups(unprocessData)
      }
      isOpen={isOpen}
      items={toItems(data)}
      paypalInfo={paypalURL ? { paypalUrl: paypalURL } : null}
      phoneInfo={phoneCode ? { phoneCode, phoneUrl: phoneURL } : null}
      serviceFee={data.serviceFee ?? 0}
      settlementFee={data.settlementFee ?? 0}
      shippingFee={data.shippingFee ?? 0}
      status={data.status}
    />
  );
};

export default ConfirmCvsPayment;
